import app from 'flarum/app';
import Component from 'flarum/Component';

/* global m */

export default class ErrorPage extends Component {
    view() {
        const {error} = this.props;

        return m('div', [
            m('h3', app.translator.trans('kilowhat-formulaire.forum.error-page.' + error + '-title')),
            m('p', app.translator.trans('kilowhat-formulaire.forum.error-page.' + error + '-description')),
        ]);
    }
}
